import { render } from "./noticeRead.vue?vue&type=template&id=0b7a5fc0&scoped=true"
import script from "./noticeRead.vue?vue&type=script&lang=js"
export * from "./noticeRead.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&id=0b7a5fc0&scoped=true&lang=css"
import "./noticeRead.vue?vue&type=style&index=1&id=0b7a5fc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7a5fc0"]])

export default __exports__